import { Box, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../SectionHeader'
import { DONUT_DOMINANT, DONUT_DOMINANT_PCT, DONUT_SLICES } from './resultsMockData'

/** Aggregate emotion mix donut with a "dominant emotion" center label + legend. */
export default function DonutCard() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  const R = 56
  const total = 100
  let acc = 0
  const arcs = DONUT_SLICES.map((s) => {
    const a0 = (acc / total) * Math.PI * 2 - Math.PI / 2
    acc += s.pct
    const a1 = (acc / total) * Math.PI * 2 - Math.PI / 2
    const x0 = 80 + R * Math.cos(a0)
    const y0 = 80 + R * Math.sin(a0)
    const x1 = 80 + R * Math.cos(a1)
    const y1 = 80 + R * Math.sin(a1)
    const large = a1 - a0 > Math.PI ? 1 : 0
    return { k: s.k, d: `M ${x0} ${y0} A ${R} ${R} 0 ${large} 1 ${x1} ${y1}` }
  })

  return (
    <Box sx={{ bgcolor: c.white, border: `1px solid ${c.ink08}`, borderRadius: '16px', p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <SectionHeader title={t('donut.title')} subtitle={t('donut.sub')} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <svg width={160} height={160} viewBox="0 0 160 160" style={{ flex: '0 0 160px' }}>
          {arcs.map((a) => (
            <path key={a.k} d={a.d} fill="none" stroke={theme.affexy.emotion[a.k]} strokeWidth={14} strokeLinecap="butt" />
          ))}
          <text x="80" y="76" textAnchor="middle" fontFamily={theme.affexy.fonts.heading} fontWeight="700" fontSize="11" fill={c.ink48} letterSpacing=".08em">
            {t('donut.dominates')}
          </text>
          <text x="80" y="98" textAnchor="middle" fontFamily={theme.affexy.fonts.heading} fontWeight="700" fontSize="22" fill={c.ink}>
            {t(`emotion.${DONUT_DOMINANT}`)}
          </text>
          <text x="80" y="118" textAnchor="middle" fontFamily={theme.affexy.fonts.body} fontSize="14" fill={c.coral} fontWeight="700" style={{ fontVariantNumeric: 'tabular-nums' }}>
            {DONUT_DOMINANT_PCT}%
          </text>
        </svg>
        <Stack spacing={0.75} sx={{ flex: 1 }}>
          {DONUT_SLICES.slice(0, 5).map((s) => (
            <Box key={s.k} sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 12.5 }}>
              <Box component="span" sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: theme.affexy.emotion[s.k] }} />
              <Typography sx={{ color: c.ink72, flex: 1, fontSize: 12.5 }}>{t(`emotion.${s.k}`)}</Typography>
              <Typography sx={{ color: c.ink, fontWeight: 700, fontSize: 12.5, fontVariantNumeric: 'tabular-nums' }}>{s.pct}%</Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  )
}
